<div class="content mt-2 mb-3">
  <app-datatable [dataSource]="lighttagSource"
                [columns]="columns"
                [identifier]="'lighttag'"
                [actionNew]="false">
                <app-empty-table [icon]="'devices'"
                    [emptyText]="'lighttag.empty_text' | translate">
                  </app-empty-table>
  </app-datatable>
  <app-error [error]="error"></app-error>
</div>
